//-------------------------
// get overloading details
//-------------------------
export function getOverloadingDetails(avail_enc) {

  const overloading_details = {
    level: 'Not Overloaded',
    adj_move: 0,
    adj_skills: 0,
  }
  if (avail_enc < 0) {
    overloading_details.level = 'Overloaded'
    overloading_details.adj_skills = -20
    overloading_details.adj_move = -99 // flags for half movement
  }
  return overloading_details
}